import {
  BaSeBackendNoSignalPage,
  BaSeDialogContainer,
  BaSeErrorPage,
  BaSeForbiddenPage,
  BaSeLoadingPage,
  BaSeNotFoundPage,
  BaSeRoot,
} from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { name as appName, version as appVersion } from '../package.json';
import { Routes } from './routes';

export const App: React.FC = () => (
  <BaSeRoot>
    <Sebrae.Root
      appName={appName}
      appVersion={appVersion}
      errorPage={(error) => <BaSeErrorPage error={error} />}
      loadingPage={() => <BaSeLoadingPage />}
      notFoundPage={() => <BaSeNotFoundPage />}
      forbiddenPage={() => <BaSeForbiddenPage />}
      backendNoSignalPage={() => <BaSeBackendNoSignalPage />}
      loginRequired={false}
    >
      <Routes />
      <BaSeDialogContainer />
    </Sebrae.Root>
  </BaSeRoot>
);
